// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import MultiBandSearch from './components/MultiBandSearch.vue';
import eventBus from "../../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            new Vue({
                el: model.dom,
                template: '<MultiBandSearch :invoke="invoke" :taskList="taskList" :updateTaskList="updateTaskList" :getSelected="getSelected" :initSelected="initSelected" :themeNum="themeNum" />',
                components: {
                    MultiBandSearch
                },
                data: {
                    taskList:[],//源数据
                    getSelected:'',//后台获取已选值
                    updateTaskList:[],//后台更新源数据
                    initSelected:[],//后台初始化默认选中值
                    themeNum:"#5582F3"
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    //初始化主题色
                    if(props.themeNum){
                        this.themeNum = props.themeNum;
                    }

                    //初始化数据
                    if (props.data && props.data.hasOwnProperty('setTaskList') && props.data.setTaskList) {
                        this.taskList = JSON.parse(props.data.setTaskList);
                    }
                    if(props.data && props.data.hasOwnProperty('initSelected') && props.data.initSelected){
                        this.initSelected = JSON.parse(props.data.initSelected);
                    }

                    //数据更新bus，接受后台发送的更新数据
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        //初始化主题色
                        if(props.themeNum){
                            this.themeNum = props.themeNum;
                        }
                        //初始化数据
                        if(!props.data){return}
                        if (props.data.hasOwnProperty('setTaskList') && props.data.setTaskList) {
                            this.taskList = JSON.parse(props.data.setTaskList);
                        }
                        if(props.data.hasOwnProperty('getSelected') && props.data.getSelected){
                            this.getSelected = props.data.getSelected;
                        }
                        if(props.data.hasOwnProperty('updateTaskList') && props.data.updateTaskList){
                            this.updateTaskList = JSON.parse(props.data.updateTaskList);
                        }
                        if(props.data.hasOwnProperty('initSelected') && props.data.initSelected){
                            this.initSelected = JSON.parse(props.data.initSelected);
                        }
                    })

                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('multiBandSearch', MyComponent)
})(window.KDApi)
